module.exports = __webpack_public_path__ + "img/json.9091035b.svg";